<template>
  <div class="menuBody" >
    <OwnerInformationTree @OwnerInformationTree="getMsgFormSon" />
        <OwnerInDia :param="diaLogData" @Visible="Visible" ref="OwnerInDia"/>
    <div class="menuTool" style="width:100%;">
      <el-card class="box-card">
        <el-row :gutter="10">
            <div style="border-bottom:1px solid rgba(234, 237, 241, 1);width:100%;height:30px;margin-bottom:10px">
                业主信息列表
            </div>
            <div style="width:150px;float:left;">
                 <el-input placeholder="请输入业主姓名" size="small"     v-model="floorCode"></el-input>
            </div>
             <div style="width:150px;float:left;margin-left:80px">
                 <el-input placeholder="请输入房间号" size="small"     v-model="floorName"></el-input>
            </div>

            <div style="float:right; margin-right:20px">
                <el-button type="primary" size="small" plain style="background: #38A38A;color:#fff;border-radius:9px;" v-Jurisdiction="'wy:web:customer:om:moveOut'" @click="Emigration()">迁出</el-button>
            </div>
            <div style="float:right;margin-right:10px">
                <el-button type="primary" size="small" plain style="background: #38A38A;color:#fff;border-radius:9px;" v-Jurisdiction="'wy:web:customer:om:moveIn'" @click="Immigration()">迁入</el-button>
            </div>
                        <div style="float:right;margin-right:20px">
                <el-button type="primary" size="small" plain  style="background: #246CE5;color:#fff;border-radius:9px;" v-Jurisdiction="'wy:web:customer:om:list'" @click="Inquire()">查询</el-button>
            </div>
    <el-table  :data="tableData" tooltip-effect="light"  v-loading="loading"    @selection-change="handleSelectionChange"    style="margin-top:30px; overflow-y: scroll;float:right" row-key="id"   :header-cell-style="{background:'#eef1f6',color:'#606266','font-weight': '600','height':'45px','text-align':'left'}" 
      :cell-style="{'text-align':'left'}"  :default-expand-all="false" :stripe="true" :tree-props="{children: 'children'}">
     <el-table-column type="selection" width="55px"></el-table-column>
    <el-table-column prop="roomName" label="房间名" ></el-table-column>
    <el-table-column prop="roomCode" label="房间号" ></el-table-column>
    <el-table-column prop="buildArea" label="面积" ></el-table-column>
    <el-table-column prop="customerName" label="业主姓名" ></el-table-column>
    <el-table-column prop="phone" label="联系电话" ></el-table-column>
    <el-table-column prop="roomStatus" label="房间状态" >
       <template slot-scope="scope">
        <el-tag v-if="scope.row.roomStatus=='1'" >空置</el-tag>
        <el-tag v-if="scope.row.roomStatus=='2'" >入住</el-tag>
        <el-tag v-if="scope.row.roomStatus=='3'" >已租</el-tag>
        <el-tag v-if="scope.row.roomStatus=='4'" >迁出</el-tag>
      </template>
    </el-table-column>
    <el-table-column prop="checkInDate" label="迁入日期" ></el-table-column>
    <el-table-column prop="chargeTime" label="开始收费日期" ></el-table-column>
    <el-table-column fixed="right" label="操作">
     <template slot-scope="scope">
          <el-button @click="editMenu(scope.row)" type="primary" icon="el-icon-edit" circle size="small" v-Jurisdiction="'wy:web:customer:om:edit'" title="修改"></el-button>
        </template>
    </el-table-column>
  </el-table>
      <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 30, 40]"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      style="float:right;margin-top:25px">
    </el-pagination>
        </el-row>
      </el-card>
    </div>

  </div>
</template>

<script>
import OwnerInDia from "./OwnerInDia.vue";
import OwnerInformationTree from "./OwnerInformationTree.vue";

export default {
  name: "OwnerInformation",
  components: {OwnerInformationTree,OwnerInDia},
  data() {
    return {
      loading:false,
        total:0,//默认数据总数
        pagesize:10,//每页的数据条数
        currentPage:1,//默认开始页面
        floorName:"",
        floorCode:"",
      tableData: [],
      options: [{
          value: '选项1',
          label: '住宅小区'
        }, {
          value: '选项2',
          label: '办公楼'
        }],
        value: '',
       optionsone: [{
          valueone: '选项1',
          labelone: '全部'
        }, {
          valueone: '选项2',
          labelone: '正式员工'
        }, {
          valueone: '选项3',
          labelone: '外包员工'
        }],
        valueone: '',
      diaLogVisible: false,
      diaLogData: {
        diaLogVisible: false,
        diaLogType: '',
        paramObj: {},
        paramList: [],
      },
      AllData:"",
      USERList:"",
      ProjectMana:"",
      floorId:"",
      floorData:{},
    }
  },
  methods: {
    handleSelectionChange(val){
      this.USERList = val
    },
    editMenu(row){

    },
    Emigration(){
      // 请选择一条房间信息！
      if(this.USERList.length  == 1){
         if(this.USERList[0].roomStatus != "4" ){
            this.$refs.OwnerInDia.title = "迁出";
            this.$refs.OwnerInDia.dialogVisible = true; 
            this.$refs.OwnerInDia.IfElese = "1"
            this.$refs.OwnerInDia.Ldata = this.USERList[0]
         }
       
      }else{
     this.$message({
        type: "warning",
        message: "请选择一条房间信息！"
      })
      }
    },
    Immigration(){
       if(this.USERList.length  == 1){
         if(this.USERList[0].roomStatus != "2"){
          this.$refs.OwnerInDia.title = "迁入";
          this.$refs.OwnerInDia.dialogVisible = true; 
          this.$refs.OwnerInDia.IfElese = "2"
          this.$refs.OwnerInDia.Ldata = this.USERList[0]
          this.$refs.OwnerInDia.floorData = this.floorData
         }else{
          this.$message({
            type: "warning",
            message: "请选择一条房间信息！"
          })           
         }
      }else{
          this.$message({
            type: "warning",
            message: "请选择一条房间信息！"
          })
      }

    },
    getMsgFormSon(data){
      this.loading = true
        if(data.id){
          this.floorId = data.id
          this.floorData = data
          this.getAllMenu()
        } 
      this.AllData = data
    },
     handleSizeChange(val) {
        this.pagesize  = val
        this.getAllMenu()
    },
    handleCurrentChange(val) {
        this.currentPage = val
        this.getAllMenu()
    },
    Inquire(){
        // 查询
         let PageSize = {
        "page":this.currentPage, // 当前页
        "size":this.pagesize,  // 每页大小
        "name":this.floorCode,
        "roomCode":this.floorName,
        "floorId":this.floorId,
      }
        this.$http.post(this.$requestUrl.POST_OWNER_LIST,PageSize).then((res) => {
          let data = res.data;
           
          if (200 === data.code) {
              this.total = data.data.total
            this.tableData = data.data.records;
            console.log(data.data.records)
          } else {
            this.$message.error(result.msg)
          }
        }).catch(() => {
          this.$message.error(this.$errorMessage.SEVER_ERROR)
        })
    },
    getAllMenu() {
      let PageSize = {
        "page":this.currentPage, // 当前页
        "size":this.pagesize,  // 每页大小
        "name":this.floorCode,
        "roomName":this.floorName,
        "floorId":this.floorId,
      }
        this.$http.post(this.$requestUrl.POST_OWNER_LIST,PageSize).then((res) => {
          let data = res.data;
          if (200 === data.code) {
            this.loading = false
            this.total = data.data.total
            this.tableData = data.data.records;
          } else {
            this.$message.error(result.msg)
            this.loading = false
          }
        }).catch(() => {
          this.loading = false
          this.$message.error(this.$errorMessage.SEVER_ERROR)
        })
      },
          Visible(data){
      if(data == false){
        this.getAllMenu();
      }
    }
  },
  mounted() {
      // this.getAllMenu();
  }
}
</script>

<style lang="scss">
.menuBody {
  width: 100%;
  .menuTool {
    .el-card {
      .el-card__body {
        padding: 10px 20px;
      }
    }

    margin-bottom: 10px;
  }

  .el-table {
    td {
      padding: 5px;
    }

    th {
      padding: 5px;
    }

    .success-row {
      background: #f0f9eb;
    }
  }

}
</style>